import React from 'react'
import { withUIContext, withDataContext } from 'context'
import { Text, Icon } from 'components/common'

const DeleteDraftPopup = ({ deleteDebate, closePopup, popupProps }) => {

    const handleDelete = () => {
        deleteDebate(popupProps.debateId)
        closePopup()
    }

    return (
        <div className='delete-draft-popup flexBoxColumn'>
            <Icon onClick={closePopup} className='op-close' />
            <Text tag='p' className='PopSemi h9' text='Deleting' />
            <Text tag='h6' className='text PopReg h6 grey' text='Are you sure you want to delete this debate?' />

            <div className='buttons flexBox justifyEnd'>
                <button onClick={handleDelete} className=' cursorPointer yes'>Yes</button>
                <button onClick={closePopup} className=' cursorPointer no'>Keep</button>
            </div>
        </div>
    )
}

export default withUIContext(withDataContext(DeleteDraftPopup,
    ['deleteDebate']),
    ['closePopup', 'popupProps'])
